/**
 * Sanitizador de PII — LGPD / GDPR compliance
 * Remove dados pessoais de payloads antes de enviar para analytics.
 */

const PII_KEYS = new Set([
  'email', 'e-mail', 'mail',
  'phone', 'telefone', 'celular', 'whatsapp',
  'cpf', 'cnpj', 'rg', 'passport',
  'senha', 'password', 'token', 'api_key',
  'nome_completo', 'full_name', 'birth_date', 'address',
]);

const PII_PATTERNS = [
  /^[\w.-]+@[\w.-]+\.\w+$/,           // email
  /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,       // CPF
  /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, // CNPJ
  /^\+?\d{10,15}$/,                     // telefone básico
];

export function sanitizeString(value: string): string {
  if (PII_PATTERNS.some(p => p.test(value))) return '[REDACTED]';
  return value;
}

export function sanitize<T extends Record<string, unknown>>(obj: T): T {
  const result = {} as T;
  for (const [key, value] of Object.entries(obj)) {
    if (PII_KEYS.has(key.toLowerCase())) continue;
    if (typeof value === 'string') {
      (result as Record<string, unknown>)[key] = sanitizeString(value);
    } else if (Array.isArray(value)) {
      (result as Record<string, unknown>)[key] = value.map(v =>
        typeof v === 'object' && v !== null ? sanitize(v as Record<string, unknown>) :
        typeof v === 'string' ? sanitizeString(v) : v
      );
    } else if (typeof value === 'object' && value !== null) {
      (result as Record<string, unknown>)[key] = sanitize(value as Record<string, unknown>);
    } else {
      (result as Record<string, unknown>)[key] = value;
    }
  }
  return result;
}
